import { render, staticRenderFns } from "./PullBill.vue?vue&type=template&id=13063b23&scoped=true"
import script from "./PullBill.vue?vue&type=script&lang=js"
export * from "./PullBill.vue?vue&type=script&lang=js"
import style0 from "./PullBill.vue?vue&type=style&index=0&id=13063b23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13063b23",
  null
  
)

export default component.exports